import * as Api from "@api";
import clsx from "clsx";
import React from "react";
import { ColorType, colorProps } from '@/components';
import styles from "./product.module.scss";

interface ProductBadgeProps
{
    tag: Api.ProductTag;
}

export const ProductBadge = ({ tag: { color, textColor, title } }: ProductBadgeProps): React.FunctionComponentElement<ProductBadgeProps> =>
{
    const bgColorProps = color !== null ? colorProps(color, ColorType.Background) : {};
    const textColorProps = textColor !== null ? colorProps(textColor) : {};

    const classes = clsx(
        styles["badge"],
        bgColorProps.className,
        textColorProps.className
    );

    const style = bgColorProps.style !== undefined || textColorProps.style !== undefined ? { ...bgColorProps.style, ...textColorProps.style } : undefined;

    return <span className={classes} style={style}>{title}</span>;
}